export default Object.freeze({
  LoadFile: 1,
  DownloadFile: 2,
});
